jQuery(document).ready(function($) {
    $('.previousUrl').click(function (e){
        e.preventDefault();
        window.history.back();
    });
});
